document.querySelectorAll('[data-product-form]').forEach((root) => {
  const variantsScript = root.querySelector('[data-product-variants]');
  if (!variantsScript) return;
  const variants = JSON.parse(variantsScript.textContent);
  const gallery = document.querySelector('[data-product-gallery]');
  const moneyFormat = (cents) => (cents / 100).toLocaleString(document.documentElement.lang || undefined, {
    style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
  });

  const optionGroups = {};
  root.querySelectorAll('[data-option-value]').forEach((el) => {
    const pos = el.dataset.optionPosition;
    (optionGroups[pos] = optionGroups[pos] || []).push(el);
  });

  const getSelected = () => {
    const selected = {};
    Object.entries(optionGroups).forEach(([pos, els]) => {
      const active = els.find((el) => {
        const radio = el.querySelector('[data-option-radio]');
        return radio ? radio.checked : el.classList.contains('is-selected');
      });
      if (active) selected[pos] = active.dataset.value;
    });
    return selected;
  };

  const findVariant = (selected) => variants.find((v) =>
    Object.entries(selected).every(([pos, value]) => v[`option${pos}`] === value)
  );

  // For every clickable option value, check whether ANY variant exists that
  // matches it together with the shopper's current picks on the OTHER
  // option positions — if not, that value can never lead to a real variant
  // from here, so it gets dimmed instead of silently doing nothing on click.
  const updateAvailability = (selected) => {
    Object.entries(optionGroups).forEach(([pos, els]) => {
      els.forEach((el) => {
        const candidate = { ...selected, [pos]: el.dataset.value };
        const reachable = variants.some((v) =>
          Object.entries(candidate).every(([p, value]) => v[`option${p}`] === value)
        );
        el.classList.toggle('is-unavailable', !reachable);
        el.setAttribute('aria-disabled', (!reachable).toString());
      });
    });
  };

  const updateRadioRowPrices = (selected) => {
    Object.entries(optionGroups).forEach(([pos, els]) => {
      if (!els[0]?.closest('.product-option__radio-rows')) return;
      els.forEach((el) => {
        const candidate = { ...selected, [pos]: el.dataset.value };
        const match = findVariant(candidate) || variants.find((v) => v[`option${pos}`] === el.dataset.value);
        if (!match) return;
        const priceEl = el.querySelector('[data-row-price]');
        const saveEl = el.querySelector('[data-row-save]');
        if (priceEl) priceEl.textContent = moneyFormat(match.price);
        if (saveEl) {
          if (match.compare_at_price > match.price) {
            const pct = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
            saveEl.hidden = false;
            saveEl.textContent = saveEl.dataset.template ? saveEl.dataset.template.replace('{{ percent }}', pct) : `Save ${pct}%`;
          } else {
            saveEl.hidden = true;
          }
        }
      });
    });
  };

  const markUnavailableCombination = () => {
    root.querySelectorAll('[data-variant-id-input]').forEach((input) => { input.value = ''; });

    const addBtn = root.querySelector('[data-add-to-cart]');
    const buyNowBtn = root.querySelector('.product-form__buy-now');
    if (addBtn) addBtn.disabled = true;
    if (buyNowBtn) buyNowBtn.disabled = true;

    const stockLine = root.querySelector('[data-stock-line]');
    const stockText = root.querySelector('[data-stock-text]');
    if (stockLine) stockLine.classList.remove('is-in-stock');
    if (stockText) stockText.textContent = stockText.dataset.unavailableText || stockText.dataset.soldOutText;
  };

  const applyVariant = (variant) => {
    if (!variant) {
      // The selected combination of options doesn't match any real variant —
      // leaving the previous variant's price/id in place would let a shopper
      // add the WRONG item to cart at the WRONG price, so block checkout
      // instead of silently doing nothing.
      markUnavailableCombination();
      return;
    }
    root.querySelectorAll('[data-variant-id-input]').forEach((input) => { input.value = variant.id; });

    const priceEl = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-compare-price]');
    if (priceEl) {
      priceEl.textContent = moneyFormat(variant.price);
      priceEl.classList.toggle('price--sale', variant.compare_at_price > variant.price);
    }
    if (compareEl) {
      if (variant.compare_at_price > variant.price) {
        compareEl.hidden = false;
        compareEl.textContent = moneyFormat(variant.compare_at_price);
      } else {
        compareEl.hidden = true;
      }
    }

    const saveBadge = root.querySelector('[data-save-badge]');
    const saveText = saveBadge?.querySelector('[data-save-text]');
    if (saveBadge && saveText) {
      if (variant.compare_at_price > variant.price) {
        const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        saveBadge.hidden = false;
        saveText.textContent = saveBadge.dataset.template ? saveBadge.dataset.template.replace('{{ percent }}', pct) : `Save ${pct}%`;
      } else {
        saveBadge.hidden = true;
      }
    }

    const addBtn = root.querySelector('[data-add-to-cart]');
    const addPrice = root.querySelector('[data-add-to-cart-price]');
    const buyNowBtn = root.querySelector('.product-form__buy-now');
    if (addBtn) addBtn.disabled = !variant.available;
    if (buyNowBtn) buyNowBtn.disabled = !variant.available;
    if (addPrice) addPrice.textContent = moneyFormat(variant.price);

    const stockLine = root.querySelector('[data-stock-line]');
    const stockText = root.querySelector('[data-stock-text]');
    if (stockLine) stockLine.classList.toggle('is-in-stock', variant.available);
    if (stockText) stockText.textContent = variant.available ? stockText.dataset.inStockText : stockText.dataset.soldOutText;

    if (variant.featured_media) gallery?.switchToMedia?.(variant.featured_media.id);

    if (window.history?.replaceState && variant.id) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  };

  const onOptionChange = () => {
    const selected = getSelected();
    Object.entries(optionGroups).forEach(([pos, els]) => {
      const legend = root.querySelector(`[data-option-current-value="${pos}"]`);
      if (legend && selected[pos]) legend.textContent = selected[pos];
    });
    updateRadioRowPrices(selected);
    updateAvailability(selected);
    applyVariant(findVariant(selected));
  };

  Object.values(optionGroups).flat().forEach((el) => {
    const radio = el.querySelector('[data-option-radio]');
    if (radio) {
      radio.addEventListener('change', onOptionChange);
    } else {
      el.addEventListener('click', () => {
        optionGroups[el.dataset.optionPosition].forEach((sibling) => {
          sibling.classList.remove('is-selected');
          if (sibling.hasAttribute('aria-pressed')) sibling.setAttribute('aria-pressed', 'false');
        });
        el.classList.add('is-selected');
        if (el.hasAttribute('aria-pressed')) el.setAttribute('aria-pressed', 'true');
        onOptionChange();
      });
    }
  });

  root.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = root.querySelector('[data-qty-input]');
      const step = btn.hasAttribute('data-qty-minus') ? -1 : 1;
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
    });
  });

  // Dim unreachable option values for the variant Liquid pre-selected on page load too.
  updateAvailability(getSelected());
});
